export default __webpack_public_path__ + "static/media/info-icon.c786c991.svg";